module.exports = __webpack_public_path__ + "assets/ee4b40b7ce15f612e70421db9bb50023.mp3";